import axios from "axios";
import {createUrlParams} from "../utils/urlParams";


export const getImportTasks = async (importTasksFilter) => {
    const urlParams = createUrlParams(importTasksFilter)
    const url = `/api/v1/async_import_tasks?${urlParams.toString()}`;
    const res = await axios.get(url);
    return res.data;
}

export const getImportTask = async (importTaskId) => {
    const res = await axios.get(`/api/v1/async_import_tasks/${importTaskId}`);
    return res.data;
}


export const createImportModel1Csv = async ({file, workgroupId, overwrite}) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('overwrite', overwrite);
    const res = await axios.post(`/api/v1/async_import_tasks/${workgroupId}/models1/csv`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;
}


export const createImportModel1Txt = async ({file, workgroupId, overwrite}) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('overwrite', overwrite);
    const res = await axios.post(`/api/v1/async_import_tasks/${workgroupId}/models1/txt`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;
}

export const createImportModel1HuskyCsv = async ({file, workgroupId, overwrite}) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('overwrite', overwrite);
    const res = await axios.post(`/api/v1/async_import_tasks/${workgroupId}/models1/husky_csv`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;
}

export const createImportModel23X23 = async ({file, workgroupId, overwrite}) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('overwrite', overwrite);
    const res = await axios.post(`/api/v1/async_import_tasks/${workgroupId}/models23/x23`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;
}

export const createImportModel23Caamlv6 = async ({file, workgroupId, overwrite}) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('overwrite', overwrite);
    const res = await axios.post(`/api/v1/async_import_tasks/${workgroupId}/models23/caamlv6`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
    return res.data;

}

export const getImportTaskErrors = async (importTaskId, data) => {
    const urlParams = createUrlParams(data)
    const res = await axios.get(`/api/v1/async_import_tasks/${importTaskId}/errors?${urlParams.toString()}`);
    return res.data;
}